import { SubscriberModel } from "../../subscriber/models/SubscriberModel";

export class BillingSubscriberProductModel {
    idProduct: string = "";
    dueDay: number = 0;
    billingEnabled: boolean = false;
    isActive: boolean = false;
    canceledAt: Date|string|null = null;
    subscriber: SubscriberModel;

    constructor(s?:Partial<BillingSubscriberProductModel>) {
        Object.assign(this, s)

        this._parseSubscriber()
    }

    private _parseSubscriber():void {
        this.subscriber = new SubscriberModel(this.subscriber)
    }
}
